import { FeatureCategory } from '../types';

export const professionalContextFeatures: FeatureCategory = {
  name: "Professional Care Context Rules",
  icon: "ShieldCheck",
  features: [
    { 
      name: "Shift Schedule Widget", 
      description: "Widget displaying assigned shifts and schedule for professional caregivers.",
      starter: "—", max: "—", family: "—", familyPlus: "—", careAddOn: "✔"
    },
    { 
      name: "Documentation Compliance Rules", 
      description: "Automatic compliance checks for care documentation requirements.",
      starter: "—", max: "—", family: "—", familyPlus: "—", careAddOn: "✔"
    },
    { 
      name: "Required Summary Note", 
      description: "Mandatory summary notes at end of shifts for professional accountability.",
      starter: "—", max: "—", family: "—", familyPlus: "—", careAddOn: "✔"
    },
    { 
      name: "Supervisor Notes (Read-Only)", 
      description: "View notes and instructions from supervisors or agency administrators.",
      starter: "—", max: "—", family: "—", familyPlus: "—", careAddOn: "✔"
    },
    { 
      name: "Agency Info Display", 
      description: "Display of agency information and branding within the caregiver's view.",
      starter: "—", max: "—", family: "—", familyPlus: "—", careAddOn: "✔"
    },
    { 
      name: "Auto-Tag Agency in Notes", 
      description: "Automatic tagging of care notes with agency identification for tracking.",
      starter: "—", max: "—", family: "—", familyPlus: "—", careAddOn: "✔"
    }
  ]
};
